/**
 * Event.disp_mode によるUI切り替え定数。
 *
 * Event.id は環境(DB)ごとに値が異なりうるため、UI切り替えの判定には
 * event.name(文字列比較)やevent.id ではなく、必ずこの disp_mode を使うこと。
 * (api_server側 api_server/models.py の Event.disp_mode と対応)
 */
export const DISP_MODE = {
  SAILING: 1,
  ROWING: 2,
  FREE_PRACTICE: 3,
  WIND_FOIL: 4,
  WIND_SLALOM: 5,
  WING_FOIL: 6,
  AUTO_RACE: 7,
};

// Sailingと同じUI(Polarタブ、Pitch/Heel表示など)を使うdisp_mode
const SAILING_LIKE_DISP_MODES = [
  DISP_MODE.SAILING,
  DISP_MODE.WIND_FOIL,
  DISP_MODE.WIND_SLALOM,
  DISP_MODE.WING_FOIL,
];

export function isSailingLike(event) {
  return !!event && SAILING_LIKE_DISP_MODES.includes(event.disp_mode);
}

export function isAutoRace(event) {
  return !!event && event.disp_mode === DISP_MODE.AUTO_RACE;
}
